import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { SERVICE_PILLARS } from '../../mock';

const SiteFooter = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-[#0a1d3a] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="h-9 w-9 rounded-lg bg-white/10 flex items-center justify-center"><Icons.House className="h-5 w-5 text-white" /></span>
            <span className="font-display font-extrabold text-lg text-white">Check-a-Property</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">Independent property inventory, safety and maintenance reporting for landlords, agents and contractors — booked and tracked in one place.</p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICE_PILLARS.map((p) => <li key={p.id}><button onClick={() => navigate('/services')} className="hover:text-white">{p.name}</button></li>)}
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><button onClick={() => navigate('/property-managers')} className="hover:text-white">Property Managers</button></li>
            <li><button onClick={() => navigate('/contractors')} className="hover:text-white">Contractors</button></li>
            <li><button onClick={() => navigate('/franchise')} className="hover:text-white">Franchise Operators</button></li>
            <li><button onClick={() => navigate('/contact')} className="hover:text-white">Contact</button></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Icons.Mail className="h-4 w-4 text-[#5b9bf3]" /> hello@check-a-property.co.uk</li>
            <li className="flex items-center gap-2"><Icons.Phone className="h-4 w-4 text-[#5b9bf3]" /> 0330 123 4567</li>
          </ul>
          <button onClick={() => navigate('/book')} className="mt-5 px-5 py-2.5 rounded-lg bg-white text-[#102d55] font-semibold text-sm hover:bg-slate-100 transition-colors">Book a service</button>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <span>© 2025 Check-a-Property. All rights reserved.</span>
          <div className="flex gap-5"><button className="hover:text-white">Privacy</button><button className="hover:text-white">Terms</button></div>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
